// Generated by Melange

import * as Fx from "../fx/fx.jsx";
import * as StoreFx__Pause from "./pause.jsx";
import * as StoreFx__SetCurrentTime from "./setCurrentTime.jsx";

function make(param) {
  return Fx.Monad_syntax.let$star(StoreFx__Pause.make(undefined), (function (param) {
    return StoreFx__SetCurrentTime.make(function (param) {
      return 0.0;
    });
  }));
}

export {
  make,
}
/* StoreFx__Pause Not a pure module */
